<app-step-wrapper [title]="dataService.steps[0]">
  <form [formGroup]="dataService.enrollmentForm" (click)="dataService.printForm()">
    <app-form-grid>
      <div>
        <app-label>Seleziona la sede:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'sede'"
          [options]="dataService.headquartersListing">
        </app-radio-button>
      </div>
      <div>
        <app-label>Seleziona l'anno scolastico:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'anno_scolastico'"
          [options]="scholasticYearsListing">
        </app-radio-button>
        <app-form-control-error-handler [abstractControl]="dataService.enrollmentForm.get('anno_scolastico')">
        </app-form-control-error-handler>
      </div>
      <div>
        <app-label>Seleziona l'indirizzo di studi:</app-label>
        <p-dropdown [classList]="'tw-w-full'" formControlName="dipartimento"
          [options]="dataService.dynamicDepartmentsListing" placeholder="Seleziona l'indirizzo di studi">
        </p-dropdown>
        <app-form-control-error-handler [abstractControl]="dataService.enrollmentForm.get('dipartimento')">
        </app-form-control-error-handler>
      </div>
      <div>
        <app-label>Seleziona l'anno accademico:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'anno'"
          [options]="dataService.dynamicAcademicYearsListing">
        </app-radio-button>
        <app-form-control-error-handler [abstractControl]="dataService.enrollmentForm.get('anno')">
        </app-form-control-error-handler>
      </div>
      <div>
        <app-label>Prima lingua:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'prima_lingua'"
          [options]="[{label:'Inglese', value:'Inglese'}]">
        </app-radio-button>
      </div>
      <div
        *ngIf="['Secondaria di I Grado', 'Liceo delle Scienze Umane', 'ITEM'].includes(dataService.enrollmentForm.get('dipartimento')?.value)">
        <app-label>Seconda lingua:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'seconda_lingua'"
          [options]="[{label:'Spagnolo', value:'Spagnolo'}]">
        </app-radio-button>
      </div>
      <div *ngIf="dataService.enrollmentForm.get('dipartimento')?.value === 'Liceo Linguistico Internazionale'">
        <app-label>Seconda lingua:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'seconda_lingua'"
          [options]="[{label:'Francese', value:'Francese'},{label:'Tedesco', value:'Tedesco'}]">
        </app-radio-button>
      </div>
      <div *ngIf="dataService.enrollmentForm.get('dipartimento')?.value === 'Liceo Linguistico Internazionale'">
        <app-label>Terza lingua:</app-label>
        <app-radio-button [xFormGroup]="dataService.enrollmentForm" [xFormControlName]="'terza_lingua'"
          [options]="[{label:'Spagnolo', value:'Spagnolo'}]">
        </app-radio-button>
      </div>
    </app-form-grid>
    <div class="tw-mt-16 tw-rounded tw-border tw-p-4" formGroupName="ultimo_anno">
      <app-form-grid>
        <div class="tw-col-span-1 md:tw-col-span-2">
          <div class="tw-flex tw-flex-row tw-justify-between">
            <div>
              Informazioni relative all'anno scolastico e Istituto nei quali lo studente ha frequentato l'ultima classe
              o sostenuto esami:
            </div>
          </div>
        </div>
        <div>
          <app-label>Nome Istituto:</app-label>
          <input pInputText toUpperCase formControlName="istituto" type="text" class="tw-w-full" />
          <app-form-control-error-handler [abstractControl]="dataService.enrollmentForm.get('ultimo_anno.istituto')">
          </app-form-control-error-handler>
        </div>
        <div>
          <app-label>Anno scolastico:</app-label>
          <p-inputMask placeholder="YYYY-YYYY" formControlName="anno_scolastico" type="text" class="tw-w-full"
            mask="2099-2099" />
          <app-form-control-error-handler
            [abstractControl]="dataService.enrollmentForm.get('ultimo_anno.anno_scolastico')">
          </app-form-control-error-handler>
        </div>
        <div class="tw-col-span-1 md:tw-col-span-2">
          <app-label>Seleziona un'opzione:</app-label>
          <app-radio-button [xFormGroup]="dataService.enrollmentForm.get('ultimo_anno')" [xFormControlName]="'tipo'"
            [options]="lastYearOptions">
          </app-radio-button>
          <app-form-control-error-handler [abstractControl]="dataService.enrollmentForm.get('ultimo_anno.tipo')">
          </app-form-control-error-handler>
        </div>
        <div>
          <app-label>{{detailsLabel}}:</app-label>
          <input pInputText toUpperCase placeholder="{{detailsPlaceholder}}" formControlName="dettaglio" type="text"
            class="tw-w-full" />
          <app-form-control-error-handler [abstractControl]="dataService.enrollmentForm.get('ultimo_anno.dettaglio')">
          </app-form-control-error-handler>
        </div>
        <div>
          <app-label [optional]="true">Esito:</app-label>
          <p-dropdown [classList]="'tw-w-full'" formControlName="esito" [options]="resultsListing"
            placeholder="Seleziona l'esito">
          </p-dropdown>
        </div>
      </app-form-grid>
    </div>
  </form>
</app-step-wrapper>
